"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casalecchio-di-reno": {
    "6210ab9d": [{
      "hkey": "6fd4c882",
      "slug": "zona-industriale-via-del-lavoro",
      "name": "Zona Industriale Via del Lavoro",
      "primary": true,
      "skipSearch": false
    }],
    "palamagti": [{
      "hkey": "6fd4c882",
      "slug": "zona-industriale-via-del-lavoro",
      "name": "Zona Industriale Via del Lavoro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "48619213": [{
      "hkey": "d462185f",
      "slug": "talon",
      "name": "Talon",
      "primary": true,
      "skipSearch": false
    }, {
      "hkey": "b5807cce",
      "slug": "croce",
      "name": "Croce",
      "primary": false,
      "skipSearch": false
    }],
    "porrettana": [{
      "hkey": "d462185f",
      "slug": "talon",
      "name": "Talon",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "casalecchio-di-reno"
    }],
    "43a76a74": [{
      "hkey": "1f8b16ec",
      "slug": "casalecchio-di-reno",
      "name": "Casalecchio di Reno",
      "primary": true,
      "skipSearch": false
    }],
    "tizzano": [{
      "hkey": "1f8b16ec",
      "slug": "casalecchio-di-reno",
      "name": "Casalecchio di Reno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ba720f8c": [{
      "hkey": "3329f2d0",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "zona-centro": [{
      "hkey": "3329f2d0",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;